import { Component } from "react";

// Last line of defence: a render error must never leave the user on a blank dark screen.
export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6" data-testid="app-error-boundary">
        <div className="sc-card p-8 w-full max-w-md space-y-4">
          <h1 className="font-heading text-2xl font-extrabold text-slate-100">Something went wrong</h1>
          <p className="text-sm text-slate-400">The page hit an unexpected error. Your data is safe — reload to continue, or return to sign in.</p>
          <button onClick={() => window.location.reload()} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold py-2 rounded" data-testid="error-boundary-reload">Reload page</button>
          <a href="/login" className="block text-center text-sm text-amber-400 underline" data-testid="error-boundary-login">Go to sign in</a>
        </div>
      </div>
    );
  }
}
